"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Objects_1 = require("../../Utility/Objects");
// eslint-disable-next-line max-lines-per-function
(() => {
    /**
     * Set elements value based on array data. Is only applicable for checkboxes
     */
    function setCheckboxValues(elements, values, excludeDisabled) {
        // cast array to string array
        const data = values.map(value => String(value).trim());
        elements.forEach((element) => {
            if (element.type !== 'checkbox') {
                throw new Error('Can\'t set multi values to element: ' + element.name);
            }
            if (excludeDisabled && element.disabled) {
                return;
            }
            element.checked = data.includes(element.value.trim());
        });
    }
    /**
     * Set multiple values for a single element. Is only applicable for select-multiple
     */
    function setMultiSelectValue(element, values) {
        if (element.type !== 'select-multiple') {
            throw new Error('Can\'t set multi values to element: ' + element.name);
        }
        // cast array values to string
        const data = values.map(value => String(value).trim());
        element.querySelectorAll('option').forEach((option) => {
            option.selected = data.includes(option.value.trim());
        });
    }
    /**
     * Set a value for multiple elements. Only applicable for radio inputs
     */
    function setRadioInputValue(elements, value, excludeDisabled) {
        value = String(value).trim();
        elements.forEach((element) => {
            if (element.type !== 'radio') {
                throw new Error('Can\'t set value `' + value + '` for multiple non-radio elements');
            }
            if (excludeDisabled && element.disabled) {
                return;
            }
            if (element.value.trim() === value) {
                element.checked = true;
            }
        });
    }
    /**
     * Set a value for a single element.
     */
    function setSingleInputValue(element, value) {
        switch (element.type) {
            case 'checkbox':
            case 'radio':
                element.checked = element.value === String(value).trim();
                break;
            default:
                element.value = value ? String(value).trim() : '';
        }
    }
    // eslint-disable-next-line max-lines-per-function
    HTMLElement.prototype.setFormData = function setFormData(data, options) {
        var _a, _b;
        const includeDisabled = (_a = options === null || options === void 0 ? void 0 : options.includeDisabled) !== null && _a !== void 0 ? _a : false;
        const strict = (_b = options === null || options === void 0 ? void 0 : options.strict) !== null && _b !== void 0 ? _b : true;
        data = Objects_1.default.flatten(data);
        // iterate over key, value. Find each element and set the value
        for (const [name, value] of Object.entries(data)) {
            let elms;
            if (Array.isArray(value)) {
                elms = this.querySelectorAll(`[name="${name}[]"],[name="${name}"]`);
                if (elms.length === 0) {
                    if (strict) {
                        throw new Error(`Unable to find element for value: [name="${name}"]`);
                    }
                    else {
                        continue;
                    }
                }
                if (elms.length > 1) {
                    // many elements, many values
                    setCheckboxValues(elms, value, includeDisabled === false);
                }
                else {
                    if (elms.item(0).disabled && includeDisabled === false) {
                        continue;
                    }
                    // single element, many values
                    setMultiSelectValue(elms.item(0), value);
                }
            }
            else {
                elms = this.querySelectorAll(`[name="${name}"]`);
                if (elms.length === 0) {
                    if (strict) {
                        throw new Error(`Unable to find element for value: [name="${name}"]`);
                    }
                    else {
                        continue;
                    }
                }
                if (elms.length > 1) {
                    // many elements, single value
                    setRadioInputValue(elms, value, includeDisabled === false);
                }
                else {
                    if (elms.item(0).disabled && includeDisabled === false) {
                        continue;
                    }
                    // single element, single value
                    setSingleInputValue(elms.item(0), value);
                }
            }
        }
    };
})();
//# sourceMappingURL=SetFormData.js.map